import { Component, Input } from '@angular/core';
import AppSettings from 'src/app/common/app.settings';
import AppValues from 'src/app/common/app.values';
import { MessengerMessage, MessengerMessagesTypes } from '../../interfaces/messenger.interface';
@Component({
  selector: 'app-messenger-dropdown-item',
  templateUrl: './messenger-dropdown-item.component.html',
  styleUrls: ['./messenger-dropdown-item.component.scss'],
})
export class MessengerDropdownItemComponent {
  @Input({ required: true }) public message: MessengerMessage;

  public readonly MessengerMessagesTypes: typeof MessengerMessagesTypes = MessengerMessagesTypes;
  public readonly DEFAULT_PROFILE_IMAGE: string = AppSettings.NO_PHOTO_DEFAULT_IMAGE;
  public readonly DATE_TIME_FORMAT_SHORT: string = AppValues.DATE_TIME_FORMAT_SHORT;
}
